import { supabase } from '../lib/supabase';

export const emailPreferencesService = {
  async getPreferences(userId) {
    try {
      const { data, error } = await supabase
        ?.from('email_preferences')
        ?.select('*')
        ?.eq('user_id', userId)
        ?.single();
      
      if (error) {
        // If no preferences exist, return defaults
        if (error?.code === 'PGRST116') {
          return {
            transactionEmails: true,
            transactionFrequency: 'immediate',
            securityEmails: true,
            securityFrequency: 'immediate',
            accountEmails: true,
            accountFrequency: 'immediate',
            paymentConfirmations: true,
            failedTransactions: true,
            subscriptionRenewals: true,
            billingAlerts: true
          };
        }
        throw error;
      }
      
      // Convert snake_case to camelCase
      return {
        id: data?.id,
        userId: data?.user_id,
        transactionEmails: data?.transaction_emails,
        transactionFrequency: data?.transaction_frequency,
        securityEmails: data?.security_emails,
        securityFrequency: data?.security_frequency,
        accountEmails: data?.account_emails,
        accountFrequency: data?.account_frequency,
        paymentConfirmations: data?.payment_confirmations,
        failedTransactions: data?.failed_transactions,
        subscriptionRenewals: data?.subscription_renewals,
        billingAlerts: data?.billing_alerts,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (err) {
      console.error('Error fetching email preferences:', err);
      throw err;
    }
  },

  async updatePreferences(userId, updates) {
    try {
      // Convert camelCase to snake_case for database
      const dbUpdates = {};
      if (updates?.transactionEmails !== undefined) dbUpdates.transaction_emails = updates?.transactionEmails;
      if (updates?.transactionFrequency !== undefined) dbUpdates.transaction_frequency = updates?.transactionFrequency;
      if (updates?.securityEmails !== undefined) dbUpdates.security_emails = updates?.securityEmails;
      if (updates?.securityFrequency !== undefined) dbUpdates.security_frequency = updates?.securityFrequency;
      if (updates?.accountEmails !== undefined) dbUpdates.account_emails = updates?.accountEmails;
      if (updates?.accountFrequency !== undefined) dbUpdates.account_frequency = updates?.accountFrequency;
      if (updates?.paymentConfirmations !== undefined) dbUpdates.payment_confirmations = updates?.paymentConfirmations;
      if (updates?.failedTransactions !== undefined) dbUpdates.failed_transactions = updates?.failedTransactions;
      if (updates?.subscriptionRenewals !== undefined) dbUpdates.subscription_renewals = updates?.subscriptionRenewals;
      if (updates?.billingAlerts !== undefined) dbUpdates.billing_alerts = updates?.billingAlerts;

      const { data, error } = await supabase
        ?.from('email_preferences')
        ?.update(dbUpdates)
        ?.eq('user_id', userId)
        ?.select()
        ?.single();
      
      if (error) throw error;

      // Convert snake_case to camelCase
      return {
        id: data?.id,
        userId: data?.user_id,
        transactionEmails: data?.transaction_emails,
        transactionFrequency: data?.transaction_frequency,
        securityEmails: data?.security_emails,
        securityFrequency: data?.security_frequency,
        accountEmails: data?.account_emails,
        accountFrequency: data?.account_frequency,
        paymentConfirmations: data?.payment_confirmations,
        failedTransactions: data?.failed_transactions,
        subscriptionRenewals: data?.subscription_renewals,
        billingAlerts: data?.billing_alerts,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (err) {
      console.error('Error updating email preferences:', err);
      throw err;
    }
  },

  async createPreferences(userId) {
    try {
      const { data, error } = await supabase
        ?.from('email_preferences')
        ?.insert({ user_id: userId })
        ?.select()
        ?.single();
      
      if (error) throw error;

      // Convert snake_case to camelCase
      return {
        id: data?.id,
        userId: data?.user_id,
        transactionEmails: data?.transaction_emails,
        transactionFrequency: data?.transaction_frequency,
        securityEmails: data?.security_emails,
        securityFrequency: data?.security_frequency,
        accountEmails: data?.account_emails,
        accountFrequency: data?.account_frequency,
        paymentConfirmations: data?.payment_confirmations,
        failedTransactions: data?.failed_transactions,
        subscriptionRenewals: data?.subscription_renewals,
        billingAlerts: data?.billing_alerts,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (err) {
      console.error('Error creating email preferences:', err);
      throw err;
    }
  }
};